import { Link, useSearchParams } from 'react-router-dom';

const REASONS: Record<string, { title: string; hint: string }> = {
  not_provisioned: {
    title: 'ยังไม่มีสิทธิ์เข้าใช้งาน',
    hint: 'ส่ง LINE user id ด้านล่างให้ super admin เพื่อขอเปิดสิทธิ์',
  },
  line_denied: {
    title: 'คุณยกเลิกการอนุญาตที่ LINE',
    hint: 'ลองเข้าสู่ระบบใหม่อีกครั้ง',
  },
  line_exchange: {
    title: 'เชื่อม LINE ไม่สำเร็จ',
    hint: 'ลองใหม่ ถ้ายังพบปัญหา ส่งเวลาที่เกิดให้ admin ตรวจสอบ',
  },
  no_token: {
    title: 'ไม่พบ token',
    hint: 'กรุณาเข้าสู่ระบบใหม่',
  },
};

export default function AuthError() {
  const [sp] = useSearchParams();
  const reason = sp.get('reason') ?? 'unknown';
  const lineUserId = sp.get('line_user_id');
  const displayName = sp.get('display_name');
  const meta = REASONS[reason] ?? {
    title: 'เกิดข้อผิดพลาด',
    hint: 'ลองใหม่อีกครั้ง',
  };

  return (
    <main className="grid min-h-screen place-items-center px-6">
      <div className="w-full max-w-md rounded-2xl border border-red-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-red-700">{meta.title}</h1>
        <p className="mt-1 text-sm text-slate-600">{meta.hint}</p>

        {lineUserId && (
          <div className="mt-4 rounded-lg bg-slate-50 p-3 font-mono text-xs">
            <div className="text-slate-500">LINE user id</div>
            <div className="mt-1 break-all">{lineUserId}</div>
            {displayName && (
              <>
                <div className="mt-2 text-slate-500">Display name</div>
                <div className="mt-1">{displayName}</div>
              </>
            )}
          </div>
        )}

        <Link
          to="/login"
          className="mt-6 block rounded-xl bg-slate-900 px-4 py-2.5 text-center text-sm font-semibold text-white"
        >
          กลับไปหน้า Login
        </Link>
      </div>
    </main>
  );
}
